import { Badge, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { UserPermission } from 'constants/user.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { CustomBadge, CustomBadgeSum } from 'theme/layouts/navbar';
import { getUserPermission } from 'state/reducers/user.reducers';

export default function NotificationsBoxHeader({ handleMarkAsRead, unreadAmount }) {
	const userPermission = useAppSelector(getUserPermission);

	const theme = useTheme();
	const t = useAppSelector(selectTranslations);

	return (
		<Box
			sx={{
				height: '24px',
				marginBlock: '12px',
				padding: '0 15px',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'baseline',
			}}
		>
			<Box sx={{ display: 'flex' }}>
				<Typography variant="boldLarge" sx={{ color: theme.palette.root.basicDeepBlue, margin: 0 }}>
					{t('header.notifications.title.main_title.text')}
				</Typography>
				{unreadAmount > 0 && (
					<CustomBadge>
						<CustomBadgeSum>
							<Badge badgeContent={unreadAmount}></Badge>
						</CustomBadgeSum>
					</CustomBadge>
				)}
			</Box>
			{userPermission !== UserPermission.VIEWER && unreadAmount > 0 && (
				<Typography
					variant="boldSmall"
					sx={{
						color: theme.palette.root.ux07777,
						'&:hover': { cursor: 'pointer' },
					}}
					onClick={handleMarkAsRead}
				>
					{t('header.notifications.buttons.mark_as_read.text')}
				</Typography>
			)}
		</Box>
	);
}
